import { render, staticRenderFns } from "./GuoCaipanList.vue?vue&type=template&id=b3d72320&"
import script from "./GuoCaipanList.vue?vue&type=script&lang=js&"
export * from "./GuoCaipanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports